import Bugsnag from "@bugsnag/js";
import { ANALYTIC_EVENTS, sendAnalytics } from "@/utils/analytics";
import { DEFAULT_NOTIFICATION_PAYLOAD, NOTIFICATION_VARIANTS } from "@/utils/applicationConstants";
import { showNotification } from "@/redux/actions/notification";
import { requestCloseModal } from "@/redux/actions/modal";
import { setProcessingState } from "@/redux/reducers/modalConfirmation";
import { contactService } from "@/modules/contacts/store/services/contact-service";
import {
  CONTACT_SERVICE_TAG,
  DRAFT_CONTACT_SERVICE_TAG,
} from "@/modules/contacts/utils/contact-service-tags";
import { LIST_SERVICE_TAG } from "@/shared/store/service/commonServiceTags";

const updateDraftContacts = contactService.injectEndpoints({
  endpoints: builder => ({
    updateDraftContacts: builder.mutation({
      query: body => ({
        url: "contacts/drafts/bulk",
        method: "PUT",
        body,
      }),
      invalidatesTags: [
        { type: DRAFT_CONTACT_SERVICE_TAG, id: LIST_SERVICE_TAG },
        { type: CONTACT_SERVICE_TAG, id: LIST_SERVICE_TAG },
      ],
      async onQueryStarted({ changedRecords, deletedRecords }, { dispatch, queryFulfilled }) {
        try {
          dispatch(setProcessingState(true));
          await queryFulfilled;

          const totalRecords = changedRecords.length + deletedRecords.length;

          sendAnalytics(ANALYTIC_EVENTS.CONTACTS_REVIEWED, totalRecords);
          dispatch(
            showNotification({
              ...DEFAULT_NOTIFICATION_PAYLOAD,
              message: {
                ...DEFAULT_NOTIFICATION_PAYLOAD.message,
                description: `${totalRecords} contact(s) processed!`,
                options: {
                  variant: NOTIFICATION_VARIANTS.SUCCESS,
                },
              },
            }),
          );
          dispatch(requestCloseModal());
        } catch (err) {
          dispatch(setProcessingState(false));
          Bugsnag.notify(err);
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useUpdateDraftContactsMutation } = updateDraftContacts;

